import script from "./AgentsTableCheckboxCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentsTableCheckboxCell.vue?vue&type=script&setup=true&lang=ts"

import "./AgentsTableCheckboxCell.vue?vue&type=style&index=0&id=816bccfc&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-816bccfc"]])

export default __exports__